export default __webpack_public_path__ + "static/media/Last-Week-Sales.3eee4775.svg";